import { post as post2, get as get2 } from 'aws-amplify/api';
import { setParams, getHeader, getSubPath, getApiName } from './utils';

const get = (path, params) => {
    return new Promise(async (resolve, reject) => {
        let header = await getHeader();
        let url = setParams(getSubPath(header) + path, params);
        const apiName = getApiName();
        const restOperation = get2({
            apiName: apiName,
            path: url,
            options: header,
        });
        try {
            const { body } = await restOperation.response;
            const json = await body.json();

            resolve(json);
        } catch (error) {
            reject(error);
        }
    });
};

const post = (path, data) => {
    return new Promise(async (resolve, reject) => {
        let header = await getHeader();
        let url = getSubPath(header) + path;
        header['body'] = data;

        const restOperation = post2({
            apiName: getApiName(),
            path: url,
            options: header,
        });
        try {
            const { body } = await restOperation.response;
            const response = await body.json();
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};

export { get, post };
